var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 7.58341C2.02341 7.58341 0.416748 5.97675 0.416748 4.00008C0.416748 2.02341 2.02341 0.416748 4.00008 0.416748C5.97675 0.416748 7.58341 2.02341 7.58341 4.00008C7.58341 5.97675 5.97675 7.58341 4.00008 7.58341ZM4.00008 0.916748C2.30008 0.916748 0.916748 2.30008 0.916748 4.00008C0.916748 5.70008 2.30008 7.08341 4.00008 7.08341C5.70008 7.08341 7.08341 5.70008 7.08341 4.00008C7.08341 2.30008 5.70008 0.916748 4.00008 0.916748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23655 5.31008C5.19322 5.31008 5.14988 5.30008 5.10988 5.27342L4.07655 4.65675C3.81988 4.50342 3.62988 4.16675 3.62988 3.87008V2.50342C3.62988 2.36675 3.74322 2.25342 3.87988 2.25342C4.01655 2.25342 4.12988 2.36675 4.12988 2.50342V3.87008C4.12988 3.99008 4.22988 4.16675 4.33322 4.22675L5.36655 4.84342C5.48655 4.91342 5.52322 5.06675 5.45322 5.18675C5.40322 5.26675 5.31988 5.31008 5.23655 5.31008Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.f8f873443d746262081fa40250321ab6.svg";